// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bb9be1d9","455":"c099cdde","977":"ed0157a4"}[chunkId] + ".chunk.js";
};